import React from 'react';
import { styled } from 'linaria/react'

const ImageContainerSkeleton = styled.div`
   .placeholder-gallery-sidebar {
      width: 100px;
    }

   .placeholder {
      border-radius: 0.1rem;
    }
`

const ProductPageImageSkeleton = () => {
    return (
       <ImageContainerSkeleton className="mb-64">
          <div className="container-fluid">
             <div className="row">
                <div className="col-auto placeholder-gallery-sidebar">
                   <div className="row">
                      <div className="col-12 px-0 pb-8">
                         <div className="ratio ratio-1x1 placeholder placeholder-wave"></div>
                      </div>
                      <div className="col-12 px-0 pb-8">
                         <div className="ratio ratio-1x1 placeholder placeholder-wave"></div>
                      </div>
                      <div className="col-12 px-0 pb-8">
                         <div className="ratio ratio-1x1 placeholder placeholder-wave"></div>
                      </div>
                   </div>
                </div>
                <div className="col pe-0">
                   <div className="ratio ratio-1x1 placeholder placeholder-wave"></div>
                </div>
             </div>
          </div>
       </ImageContainerSkeleton>
    )
}
 
export default ProductPageImageSkeleton;